import styled from "styled-components";
import { colors } from "@pepdirect/v3/styles/variables";
import { Device } from "@pepdirect/v3/styles/screenSizes";
import { ExternalLink } from "@pepdirect/v3/ui/ExternalLink";

export const StyledOrderSpecs = styled.div<{ isReviewStep: boolean }>`
  font-size: 13px;
  display: flex;
  flex-direction: column;
  gap: ${({ isReviewStep }) => (isReviewStep ? "20px" : "10px")};
  margin-bottom: 40px;
`;

export const StyledDetails = styled.div<{ isReviewStep: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ isReviewStep }) => (isReviewStep ? "20px" : "10px")};
  margin-bottom: 10px;
  width: 100%;
`;

export const StyledSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const StyledGiftConfirmationEmail = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledGiftMessage = styled.div`
  padding: 20px;
  background-color: ${colors.gray100};
  border-radius: 6px;
  margin-top: 6px;
`;

export const StyledEmail = styled.span`
  color: ${({ theme }) => theme.color.primary};
`;

export const StyledBoldText = styled.span`
  font-weight: 700;
`;

export const StyledSectionWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const StyledDetailItem = styled.div`
  display: flex;

  > :first-child {
    font-weight: 700;
    margin-right: 5px;
  }
`;

// in order to center align the checkmark icon with the header
// and have all the content below it also be indented, this
// spacer is added that is the same width as the icon.
// BUT also don't show this spacer on mobile.
export const StyledSpacer = styled.div`
  @media ${Device.laptop} {
    width: 24px;
    flex-shrink: 0;
  }
  @media ${Device.notLaptop} {
    display: none;
  }
`;

export const StyledNote = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius || "10px"};
  background-color: ${({ theme }) =>
    theme.page?.backgroundColor ? colors.white : colors.gray100};
  padding: 10px 20px;
  font-size: 13px;
`;

export const StyledExternalLink = styled(ExternalLink)`
  color: ${({ theme }) => theme.color.primary};
`;
